import { CloudServerOutlined, FileExcelOutlined, EyeOutlined, EyeInvisibleOutlined, FilePdfOutlined, InfoOutlined, CheckOutlined, CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { PageHeader, Space, Tag, Tooltip, message, notification, Popconfirm, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, dineroDisabledMask, ModalItem, RangePickerItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import VistaPrevia from "./VistaPrevia/VistaPrevia";
import facturaXmlPdf from "../../../Pdf/facturaXmlPdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import complementoXmlPdf from "../../../Pdf/complementoXmlPdf";
import RelacionarPago from "./RelacionarPago/RelacionarPago";
import AgregarAOrdenDeCompra from "./AgregarAOrdenDeCompra/AgregarAOrdenDeCompra";
import IconLink from "../../../Icons/IconLink";
import ConceptosXmlPorXmlId from "./ConceptosXmlPorXmlId";
import ModalProgreso from "../../../Components/ModalProgreso";
import SeguidorProcesoMasivo from "../../../Components/seguirProcesoMasivo";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

// Mismo tope que el backend (TOPE_VERIFICACION_XML_MASIVA): cada XML es una consulta al SAT.
const TOPE_VERIFICACION_XML_MASIVA = 100;

class ArchivosXml extends Component {
  tableRef = null;
  state = {
    todasArchivosXml: [],
    loading: false,
    emitido: 1,
    modalVistaPrevia: false,
    modalVistaPreviaId: null,
    modalRelacionarPago: false,
    modalRelacionarPagoId: null,
    modalOrdenDeCompra: false,
    modalOrdenDeCompraId: null,
    valor: 1,
    activasManual: false,
    modalSolicitud: false,
    fechasSolicitud: [moment(), moment()],
    filtroTipo: '',
    filtroUsoCfdi: [],
    todasUsosDeCFDI: [],
    selectedRowKeys: [],
    totalRecords: 0,
    todasProveedores: [],
    todasTiposDeProveedor: [],
    todasMonedas: [],
    verificandoXmlId: null,
    iniciandoVerificacionMasiva: false,
    procesandoVerificacion: false,
    progresoVerificacion: { procesados: 0, total: null },
  };
  componentDidMount() {
    this.consultarCatalogosProveedor();

    // La verificacion de los seleccionados corre en el servidor por lotes y avisa por
    // WebSocket (con respaldo por polling), igual que la masiva de Ventas.
    this.seguidorVerificacion = new SeguidorProcesoMasivo({
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
      onProgreso: (progreso) => this.setState({ procesandoVerificacion: true, progresoVerificacion: progreso }),
      onFin: (resumen) => {
        this.setState({ procesandoVerificacion: false, progresoVerificacion: { procesados: 0, total: null }, selectedRowKeys: [] });

        // Sin resumen el proceso termino pero no dejo numeros (murio, o caduco su
        // resultado): se cierra sin anunciar cifras inventadas.
        if (resumen) {
          notification.info({
            message: "Verificación terminada",
            duration: null,
            description: this.textoResumenVerificacion(resumen),
          });
        }

        this.recargarTabla();
      },
      onError: (error) => {
        this.setState({ procesandoVerificacion: false, progresoVerificacion: { procesados: 0, total: null } });
        message.error(error || "Hubo un error y no se pudo terminar la verificación");
      },
    });
    this.seguidorVerificacion.escuchar();
  }

  componentWillUnmount() {
    if (this.seguidorVerificacion) this.seguidorVerificacion.detener();
  }

  recargarTabla() {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
    }
  }

  checarEstatusXml(id) {
    this.setState({ verificandoXmlId: id });
    axios
      .post(
        "descargaMasiva/checarEstatusXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ verificandoXmlId: null });
        if (res.data.success === 2) {
          if (res.data.cancelado && res.data.cambio) {
            notification.warning({ message: "CFDI cancelado", description: res.data.message });
          } else if (res.data.cambio) {
            message.success(res.data.message);
          } else {
            message.info(res.data.message);
          }
        } else {
          // "No encontrado" y "No verificable" llegan aqui y SI se guardaron: la tabla
          // se recarga igual para que el renglon lo muestre.
          notification.warning({
            message: "Estatus SAT",
            description: res.data.message || "No se pudo consultar el estatus en el SAT",
          });
        }
        this.recargarTabla();
      })
      // El SAT es justo un servicio que se cae seguido: sin esto un timeout dejaba el
      // boton girando para siempre.
      .catch(() => {
        this.setState({ verificandoXmlId: null });
        notification.error({
          message: "Error",
          description: "No se pudo consultar el estatus en el SAT. Intenta de nuevo en unos minutos.",
        });
      });
  }

  verificarEstatusSeleccionados(ids) {
    if (ids.length > TOPE_VERIFICACION_XML_MASIVA) {
      message.warning(`Puedes verificar hasta ${TOPE_VERIFICACION_XML_MASIVA} XML a la vez`);
      return;
    }

    this.setState({ iniciandoVerificacionMasiva: true });
    axios
      .post(
        "descargaMasiva/checarEstatusXmlMasivo",
        { xmlIds: ids, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ iniciandoVerificacionMasiva: false });
        if (res.data.success === 2) {
          // Arranco. El avance y el cierre llegan por el seguidor.
          this.seguidorVerificacion.seguir(res.data.procesoId);
          this.setState({
            procesandoVerificacion: true,
            progresoVerificacion: { procesados: 0, total: res.data.total ?? null },
          });
        } else {
          // Incluye el rechazo por candado: ya hay otra operacion masiva en curso
          // para esta empresa.
          message.error(res.data.message || "Hubo un error y no se inició la verificación");
        }
      })
      .catch(() => {
        this.setState({ iniciandoVerificacionMasiva: false });
        message.error("Hubo un error y no se inició la verificación");
      });
  }

  textoResumenVerificacion(resumen) {
    const partes = [
      `Revisados: ${resumen.revisados ?? 0}`,
      `vigentes en el SAT: ${resumen.vigentes ?? 0}`,
      `cancelados en el SAT: ${resumen.canceladas ?? 0}`,
    ];

    if (resumen.canceladasContabilizadas > 0) {
      partes.push(`${resumen.canceladasContabilizadas} recién cancelados ya están registrados en el sistema (revísalos)`);
    }
    if (resumen.porConfirmar > 0) {
      partes.push(`${resumen.porConfirmar} con cancelación por confirmar`);
    }
    if (resumen.revertidas > 0) {
      partes.push(`${resumen.revertidas} estaban cancelados en el sistema y se regresaron a vigentes`);
    }
    if (resumen.noEncontradas > 0) {
      partes.push(`${resumen.noEncontradas} no los encontró el SAT`);
    }
    if (resumen.noVerificables > 0) {
      partes.push(`${resumen.noVerificables} no se pudieron verificar por datos incompletos`);
    }
    if (resumen.sinRespuesta > 0) {
      partes.push(`${resumen.sinRespuesta} sin respuesta del SAT`);
    }
    if (resumen.omitidas > 0) {
      partes.push(`${resumen.omitidas} quedaron sin consultar porque el SAT dejó de responder`);
    }

    return partes.join(". ") + ".";
  }

  consultarCatalogosProveedor() {
    axios
      .post("proveedores/selectTodosProveedores", { empresaId: this.props.empresaId, valor: 1 }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ todasProveedores: res.data });
      });
    axios
      .post("tiposdeproveedores/selectTiposDeProveedores", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ todasTiposDeProveedor: res.data });
      });
    axios
      .post("monedas/selectMonedas", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ todasMonedas: res.data });
      });
    axios
      .post("usodecfdi/selectUsosDeCFDI", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ todasUsosDeCFDI: res.data });
      });
  }

  onProveedorAlta(proveedorNuevo) {
    this.setState((prev) => ({ todasProveedores: [...prev.todasProveedores, proveedorNuevo] }));
  }

  textoUsoCfdi(codigo) {
    const uso = this.state.todasUsosDeCFDI.find((u) => u.c_UsoCFDI === codigo);
    return uso ? `${uso.c_UsoCFDI} - ${uso.descripcion}` : codigo;
  }

  onChangeFiltroUsoCfdi(valores) {
    this.setState({ filtroUsoCfdi: valores }, () => {
      if (this.tableRef) {
        this.tableRef.updateExternalFilters({
          valor: this.state.valor,
          filtroTipo: this.state.filtroTipo,
          filtroUsoCfdi: valores,
        });
      }
    });
  }

  consultarArchivosXml(params) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/selectTodosXml",
        {
          empresaId: this.props.empresaId,
          valor: this.state.valor,
          filtroTipo: this.state.filtroTipo,
          filtroUsoCfdi: this.state.filtroUsoCfdi,
          ...params,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            todasArchivosXml: res.data.data.map(value => ({
              ...value,
              formaDePago: value?.formaDePago?.c_FormaPago
                ? (value.formaDePago.c_FormaPago + ' - ' + value.formaDePago.descripcion)
                : '',
              metodoPago: value?.metodoPago || '',
              accion: {
                tipoDeComprobante: value.tipoDeComprobante,
                _id: value._id,
                contabilizada: value.contabilizada,
                nombre: value.nombre,
                cancelable: value.cancelable,
                estadoCancelacion: value.estadoCancelacion,
                fechaUltimaVerificacion: value.fechaUltimaVerificacion,
                verificacionSat: value.verificacionSat,
                estado: value.estado,
                oculto: value.oculto,
              }
            })),
            totalRecords: res.data.totalRecords || 0,
            activasManual: res.data.activasManual,
          });
        } else {
          this.setState({ todasArchivosXml: [], totalRecords: 0 });
        }
      });
  }

  descargarXml(id) {
    axios
      .post(
        "descargaMasiva/descargarXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          var xmltext = res.data.xml;

          var filename = res.data.name;
          var pom = document.createElement("a");
          var bb = new Blob([xmltext], { type: "text/plain" });

          pom.setAttribute("href", window.URL.createObjectURL(bb));
          pom.setAttribute("download", filename);

          pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(
            ":"
          );
          pom.draggable = true;
          pom.classList.add("dragout");

          pom.click();
        } else {
          message.error("Hubo un error y no se pudo descargar");
        }
      });
  }

  agregarFacturaSinOrdenDeCompra(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/datosXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.props.history.push('/panel/agregarFacturaSinOrdenDeCompra', { fileName: res.data.uuid, fileData: JSON.stringify(res.data.dataXml) })
        } else {
          message.error('Hubo un error y no se pudo redigir')
        }
      });
    this.setState({ loading: false });
  }

  agregarFacturaCajaChica(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/datosXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.props.history.push('/panel/agregarFacturaCajaChica', { fileName: res.data.uuid, fileData: JSON.stringify(res.data.dataXml) })
        } else {
          message.error('Hubo un error y no se pudo redigir')
        }
      });
    this.setState({ loading: false });
  }

  agregarNotaDeCredito(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/datosXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.props.history.push('/panel/agregarNotaDeCredito', { fileName: res.data.uuid, fileData: JSON.stringify(res.data.dataXml) })
        } else {
          message.error('Hubo un error y no se pudo redigir')
        }
      });
    this.setState({ loading: false });
  }

  agregarDevolucion(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/datosXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.props.history.push('/panel/agregarDevolucionCompra', { fileName: res.data.uuid, fileData: JSON.stringify(res.data.dataXml) })
        } else {
          message.error('Hubo un error y no se pudo redigir')
        }
      });
    this.setState({ loading: false });
  }

  traspasoConDivisas(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/datosXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.props.history.push('/panel/traspasoEntreCuentas', { xmlId: id, fileName: res.data.uuid, fileData: JSON.stringify(res.data.dataXml) })
        } else {
          message.error('Hubo un error y no se pudo redirigir')
        }
      });
    this.setState({ loading: false });
  }

  abrirVistaPrevia(id) {
    this.setState({
      modalVistaPrevia: true,
      modalVistaPreviaId: id,
    });
  }

  cerrarVistaPrevia() {
    this.setState({
      modalVistaPrevia: false,
      modalVistaPreviaId: null,
    });
  }

  descargarPdf(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/datosXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (res.data.tipoDeComprobante === 'I' || res.data.tipoDeComprobante === 'E') {
            pdfMake.createPdf(facturaXmlPdf(res.data)).download(res.data.uuid);
          } else if (res.data.tipoDeComprobante === 'P') {
            pdfMake.createPdf(complementoXmlPdf(res.data)).download(res.data.uuid);
          }
        }
      });
    this.setState({ loading: false });
  }

  abrirRelacionarPago(id) {
    this.setState({
      modalRelacionarPago: true,
      modalRelacionarPagoId: id,
    });
  }

  cerrarRelacionarPago() {
    this.setState({
      modalRelacionarPago: false,
      modalRelacionarPagoId: null,
    });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
    }
  }

  abrirModalOrdenDeCompra(id) {
    this.setState({
      modalOrdenDeCompra: true,
      modalOrdenDeCompraId: id,
    });
  }

  cerrarModalOrdenDeCompra() {
    this.setState({
      modalOrdenDeCompra: false,
      modalOrdenDeCompraId: null,
    });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
    }
  }

  aceptarCancelacion(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/aceptarCancelacion",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success('Se acepto la cancelacion')
          if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
          }
        } else {
          message.error('Hubo un error y no se pudo aceptar la cancelacion')
        }
      });
    this.setState({ loading: false });
  }

  rechazarCancelacion(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/rechazarCancelacion",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success('Se rechazo la cancelacion')
          if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
          }
        } else {
          message.error('Hubo un error y no se pudo rechazar la cancelacion')
        }
      });
    this.setState({ loading: false });
  }

  ocultarXml(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/ocultarXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
          }
        } else {
          message.error("Hubo un error al cambiar el estado del XML");
          this.setState({ loading: false });
        }
      });
  }

  desocultarXml(id) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/desocultarXml",
        { xmlId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
          }
        } else {
          message.error("Hubo un error al cambiar el estado del XML");
          this.setState({ loading: false });
        }
      });
  }

  ocultarMasivo(ids) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/ocultarXmlMasivo",
        { xmlIds: ids, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ selectedRowKeys: [] });
          if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
          };
        } else {
          message.error("Hubo un error al ocultar los XMLs");
          this.setState({ loading: false });
        }
      });
  }

  desocultarMasivo(ids) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/desocultarXmlMasivo",
        { xmlIds: ids, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ selectedRowKeys: [] });
          if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
          }
        } else {
          message.error("Hubo un error al mostrar los XMLs");
          this.setState({ loading: false });
        }
      });
  }

  async crearSolicitudDia() {
    const [fechaInicial, fechaFinal] = this.state.fechasSolicitud || [];
    if (!fechaInicial || !fechaFinal) {
      message.error('Selecciona un rango de fechas');
      return;
    }
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "descargaMasiva/crearSolicitudDia",
        {
          empresaId: this.props.empresaId,
          fechaInicial: fechaInicial.format('YYYY-MM-DD'),
          fechaFinal: fechaFinal.format('YYYY-MM-DD'),
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2) {
        this.setState({ modalSolicitud: false, activasManual: res.data.activasManual });
        message.success(`Se creó la solicitud del ${fechaInicial.format('DD/MM/YYYY')} al ${fechaFinal.format('DD/MM/YYYY')}`);
        if (window.registrarMovimiento) {
          window.registrarMovimiento({
            titulo: 'Solicitud Creada de Descarga Masiva',
            mensaje: `Se ha creado una nueva solicitud de descarga masiva de XML.`,
            icono: 7,
            onClick: () => {
              if (this.tableRef) {
                this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroTipo: this.state.filtroTipo });
              }
            }
          });
        }
      } else {
        message.error(res.data.message || 'Hubo un error y no se pudo crear la solicitud');
      }
    } catch (error) {
      message.error('Hubo un error y no se pudo crear la solicitud');
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    let columns = []
    columns =
      this.state.emitido === 2
        ? [
          {
            title: "Receptor",
            dataIndex: "receptorNombre",
            key: "receptorNombre",
            sorter: (a, b) => {
              if (a.receptorNombre < b.receptorNombre) {
                return -1;
              }
              if (a.receptorNombre > b.receptorNombre) {
                return 1;
              }
              return 0;
            },
            buscar: "receptorNombre",
          },
          {
            title: "Tipo",
            dataIndex: "tipoDeComprobante",
            key: "tipoDeComprobante",
            render: (value) => {
              if (value === "I") {
                return "I - Ingreso";
              } else if (value === "P") {
                return "P - Pago";
              } else if (value === "E") {
                return "E - Egreso";
              } else if (value === "N") {
                return "N - Nomina";
              } else if (value === "T") {
                return "T - Traslado";
              }
            },
          },
          {
            title: "Tipo Pago",
            dataIndex: "formaDePago",
            key: "formaDePago",
            sorter: (a, b) => {
              if (a.formaDePago < b.formaDePago) {
                return -1;
              }
              if (a.formaDePago > b.formaDePago) {
                return 1;
              }
              return 0;
            },
          },
          {
            title: "Dia",
            dataIndex: "fecha",
            key: "fecha",
            sorter: (a, b) => {
              if (a.fecha < b.fecha) {
                return -1;
              }
              if (a.fecha > b.fecha) {
                return 1;
              }
              return 0;
            },
            render: (value) => {
              const fecha = moment(value).format("L");
              const arr = fecha.split(" ");

              //loop through each element of the array and capitalize the first letter.

              for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
              }

              //Join all the elements of the array back into a string
              //using a blankspace as a separator
              const str2 = arr.join(" ");
              return str2;
            },
            buscar: "fecha",
          },
          {
            title: "Subtotal",
            dataIndex: "subtotal",
            key: "subtotal",
            render: (value) => dineroDisabledMask(value),
            align: "right",
          },
          {
            title: "Total",
            dataIndex: "total",
            key: "total",
            render: (value) => dineroDisabledMask(value),
            align: "right",
          },
          {
            title: "Accion",
            dataIndex: "accion",
            key: "accion",
            render: (value) => {
              return (
                <Space>
                  {value.estado === 0 &&
                    <Tag color="red" >Cancelada</Tag>
                  }
                </Space>
              );
            },
          },
        ]
        : [
          {
            title: "Serie",
            dataIndex: "serie",
            key: "serie",
            sorter: (a, b) => {
              if (a.serie < b.serie) {
                return -1;
              }
              if (a.serie > b.serie) {
                return 1;
              }
              return 0;
            },
            buscar: "serie",
            width: "5%",
          },
          {
            title: "Folio",
            dataIndex: "folio",
            key: "folio",
            sorter: (a, b) => {
              if (a.folio < b.folio) {
                return -1;
              }
              if (a.folio > b.folio) {
                return 1;
              }
              return 0;
            },
            buscar: "folio",
            width: "5%",
          },
          {
            title: "Emisor",
            dataIndex: "emisorNombre",
            key: "emisorNombre",
            sorter: (a, b) => {
              if (a.emisorNombre < b.emisorNombre) {
                return -1;
              }
              if (a.emisorNombre > b.emisorNombre) {
                return 1;
              }
              return 0;
            },
            buscar: "emisorNombre",
            width: "18%",
          },
          {
            title: "Pago",
            dataIndex: "metodoDePago",
            key: "metodoDePago",
            render: (value, record) => (
              <div>
                <div style={{ fontSize: "12px", fontWeight: "bold" }}>
                  {value}
                </div>
                <div style={{ fontSize: "12px", color: "#666" }}>
                  {record.formaDePago}
                </div>
              </div>
            ),
            width: "8%",
          },
          {
            title: "Dia",
            dataIndex: "fecha",
            key: "fecha",
            sorter: (a, b) => {
              if (a.fecha < b.fecha) {
                return -1;
              }
              if (a.fecha > b.fecha) {
                return 1;
              }
              return 0;
            },
            render: (value, record) => {
              const fecha = moment(value).format("L");
              const arr = fecha.split(" ");

              //loop through each element of the array and capitalize the first letter.

              for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
              }

              //Join all the elements of the array back into a string
              //using a blankspace as a separator
              const str2 = arr.join(" ");

              let tipoComprobante = ""

              if (record.tipoDeComprobante === 'I') {
                tipoComprobante = 'I - Ingreso'
              } else if (record.tipoDeComprobante === 'P') {
                tipoComprobante = 'P - Pago'
              } else if (record.tipoDeComprobante === 'E') {
                tipoComprobante = 'E - Egreso'
              } else if (record.tipoDeComprobante === 'N') {
                tipoComprobante = 'N - Nómina'
              } else if (record.tipoDeComprobante === 'T') {
                tipoComprobante = 'T - Traslado'
              } else {
                tipoComprobante = record.tipoDeComprobante || ""
              }

              return (
                <div>
                  <div style={{ fontSize: "12px", fontWeight: "bold" }}>
                    {str2}
                  </div>
                  <div style={{ fontSize: "12px", color: "#666" }}>
                    {tipoComprobante}
                  </div>
                </div>
              )
            },
            buscar: "fecha",
            width: "10%",
          },
          {
            title: "Subtotal/Total",
            dataIndex: "total",
            key: "total",
            render: (_, record) => (
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                  <span>{dineroDisabledMask(record.subtotal)}</span>
                  {record.moneda && <span style={{ fontSize: "12px", color: "#999" }}>{record.moneda}</span>}
                </div>
                <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                  <span>{dineroDisabledMask(record.total)}</span>
                  {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                </div>
              </div>
            ),
            align: "right",
            width: "15%",
            buscar: "total",
          },
          {
            title: "Estado",
            dataIndex: "estado",
            key: "estado",
            render: (value, record) => {
              let tags = [];

              // Estado principal
              if (value === 0) {
                tags.push(<Tag color="red" className="square-tag" key="estado-cancelada">Cancelada</Tag>);
              } else {
                tags.push(<Tag color="green" className="square-tag" key="estado-vigente">Vigente</Tag>);
              }

              // Lo que contesto el SAT en la ultima verificacion, cuando no es un estatus.
              const estadoVerificacion = record.accion?.verificacionSat?.estado;

              if (value !== 0 && record.accion?.estadoCancelacion === 1) {
                tags.push(<Tag color="gold" className="square-tag" key="estado-por-confirmar">Por confirmar</Tag>);
              }

              if (estadoVerificacion === 'No encontrado') {
                tags.push(<Tag color="orange" className="square-tag" key="estado-no-encontrado">No encontrado en SAT</Tag>);
              } else if (estadoVerificacion === 'No verificable') {
                tags.push(<Tag color="orange" className="square-tag" key="estado-no-verificable">No verificable</Tag>);
              }

              // Segunda fila: tags NC/YC e icono de información
              let secondRowElements = [];

              // Estados de contabilización para segunda fila
              if (record.accion?.estado === 1 && record.accion?.contabilizada === 1 && record.accion?.estadoCancelacion !== 1) {
                secondRowElements.push(
                  <Tooltip title="No Contabilizada" key="no-contabilizada" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <Tag color="red">NC</Tag>
                  </Tooltip>
                );
              }

              if (record.accion?.contabilizada === 2 && record.accion?.estadoCancelacion !== 1) {
                secondRowElements.push(
                  <Tooltip title="Ya Contabilizada" key="ya-contabilizada-2" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <Tag color="green">YC</Tag>
                  </Tooltip>
                );
              }

              //1 - Cancelable con aceptación
              //2 - No cancelable
              //3 - Cancelable sin aceptación


              //1 - En proceso
              //2 - Plazo vencido
              //3 - Solicitud rechazada
              //4 - Cancelado sin aceptación
              //5 - Cancelado con aceptación
              //0 - (null)
              // Generar mensaje info
              let mensajeInfo = ''

              if (record.accion?.estado !== 0) {
                if (record.accion?.cancelable === 1) {
                  mensajeInfo += '- Cancelable con aceptación'
                } else if (record.accion?.cancelable === 2) {
                  mensajeInfo += '- No cancelable'
                } else if (record.accion?.cancelable === 3) {
                  mensajeInfo += '- Cancelable sin aceptación'
                }
              }

              if (record.accion?.estadoCancelacion === 1) {
                mensajeInfo += (mensajeInfo.length > 0 ? '\n' : '') + '- En proceso'
              } else if (record.accion?.estadoCancelacion === 2) {
                mensajeInfo += (mensajeInfo.length > 0 ? '\n' : '') + '- Plazo vencido'
              } else if (record.accion?.estadoCancelacion === 3) {
                mensajeInfo += (mensajeInfo.length > 0 ? '\n' : '') + '- Solicitud rechazada'
              } else if (record.accion?.estadoCancelacion === 4) {
                mensajeInfo += (mensajeInfo.length > 0 ? '\n' : '') + '- Cancelado sin aceptación'
              } else if (record.accion?.estadoCancelacion === 5) {
                mensajeInfo += (mensajeInfo.length > 0 ? '\n' : '') + '- Cancelado con aceptación'
              }

              if (estadoVerificacion === 'No encontrado') {
                mensajeInfo += (mensajeInfo.length > 0 ? '\n' : '') + '- El SAT no encontró este CFDI con su RFC emisor, RFC receptor y total'
              } else if (estadoVerificacion === 'No verificable') {
                mensajeInfo += (mensajeInfo.length > 0 ? '\n' : '') + '- No se pudo verificar: ' + (record.accion?.verificacionSat?.mensaje || 'faltan datos del CFDI')
              }

              if (record.accion?.fechaUltimaVerificacion) {
                mensajeInfo += (mensajeInfo.length > 0 ? '\n' : '') + '- Checado ' + moment(record.accion.fechaUltimaVerificacion).fromNow()
              } else {
                mensajeInfo += (mensajeInfo.length > 0 ? '\n' : '') + '- No ha sido checado'
              }

              if (mensajeInfo) {
                secondRowElements.push(
                  <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{mensajeInfo}</span>} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '5px', minHeight: 'auto' }} key="info-icon">
                    <InfoOutlined
                      size="small"
                      style={{ color: '#00b5e2', cursor: 'pointer' }}
                    />
                  </Tooltip>
                );
              }

              return (
                <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
                    {tags}
                  </div>
                  {secondRowElements.length > 0 && (
                    <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                      {secondRowElements}
                    </div>
                  )}
                </div>
              );
            },
            align: "center",
            width: "12%",
          },
          {
            title: "Acción",
            dataIndex: "accion",
            key: "accion",
            align: "center",
            width: "30%",
            onHeaderCell: () => ({
              style: { textAlign: 'center', padding: '4px' }
            }),
            onCell: () => ({
              className: "acciones-sin-hover",
              style: { textAlign: 'center', padding: '4px' }
            }),
            render: (value, record, index) => {

              let buttons = []

              // Botones de cancelación
              const puedeAceptarCancelacion = value.estadoCancelacion === 1;
              const puedeRechazarCancelacion = value.estadoCancelacion === 1;

              buttons.push(
                <Tooltip title={puedeAceptarCancelacion ? "Aceptar cancelación factura" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <Popconfirm
                    title={`¿Estas seguro de aceptar la cancelacion de la factura?`}
                    onConfirm={() => this.aceptarCancelacion(value._id)}
                    okText="Ok"
                    cancelText="Cancelar"
                    disabled={!puedeAceptarCancelacion}
                  >
                    <ButtonItem lima size='small' icon={<CheckOutlined />} disabled={!puedeAceptarCancelacion}></ButtonItem>
                  </Popconfirm>
                </Tooltip>,
                <Tooltip title={puedeRechazarCancelacion ? "Rechazar cancelación factura" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <Popconfirm
                    title={`¿Estas seguro de rechazar la cancelacion de la factura?`}
                    onConfirm={() => this.rechazarCancelacion(value._id)}
                    okText="Ok"
                    cancelText="Cancelar"
                    disabled={!puedeRechazarCancelacion}
                  >
                    <ButtonItem rojo size='small' icon={<CloseOutlined />} disabled={!puedeRechazarCancelacion}></ButtonItem>
                  </Popconfirm>
                </Tooltip>,
                // Sin Popconfirm: verificar solo actualiza el estatus del XML, no toca
                // facturas, polizas ni pagos.
                <Tooltip key="verificar-sat" title="Verificar estatus en el SAT" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    blanco
                    size='small'
                    icon={<SearchOutlined style={{ color: '#00b5e2' }} />}
                    loading={this.state.verificandoXmlId === value._id}
                    onClick={() => this.checarEstatusXml(value._id)}
                  />
                </Tooltip>
              );

              // Botones para notas de crédito y devoluciones (tipo E)
              const puedeNotaCredito = value.contabilizada === 1 && value.tipoDeComprobante === 'E' && value.estado === 1 && value.estadoCancelacion !== 1;
              if (puedeNotaCredito) {
                buttons.push(
                  <Tooltip title={puedeNotaCredito ? "Agregar nota de credito" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      onClick={() => puedeNotaCredito && this.agregarNotaDeCredito(value._id)}
                      size='small'
                      disabled={!puedeNotaCredito}
                    >
                      N.D.C.
                    </ButtonItem>
                  </Tooltip>,
                  <Tooltip title={puedeNotaCredito ? "Agregar devolución" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      onClick={() => puedeNotaCredito && this.agregarDevolucion(value._id)}
                      size='small'
                      disabled={!puedeNotaCredito}
                    >
                      DEV.
                    </ButtonItem>
                  </Tooltip>
                );
              }

              // Botones para facturas 
              const puedeSinOrden = value.contabilizada === 1 && value.tipoDeComprobante === 'I' && (value.estado === 1 || value.estado === 6) && value.estadoCancelacion !== 1;
              const puedeCajaChica = value.contabilizada === 1 && value.tipoDeComprobante === 'I' && (value.estado === 1 || value.estado === 6) && value.estadoCancelacion !== 1;
              const puedeOrdenCompra = value.contabilizada === 1 && value.tipoDeComprobante === 'I' && (value.estado === 1 || value.estado === 6) && value.estadoCancelacion !== 1;

              if (puedeSinOrden || puedeCajaChica || puedeOrdenCompra) {

                buttons.push(
                  <Tooltip title={puedeSinOrden ? "Agregar factura sin orden de compra con este xml" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      onClick={() => puedeSinOrden && this.agregarFacturaSinOrdenDeCompra(value._id)}
                      cyan
                      size='small'
                      disabled={!puedeSinOrden}
                    >
                      S/O
                    </ButtonItem>
                  </Tooltip>,
                  <Tooltip title={puedeCajaChica ? "Agregar factura de caja chica con este xml" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      onClick={() => puedeCajaChica && this.agregarFacturaCajaChica(value._id)}
                      naranja
                      size='small'
                      disabled={!puedeCajaChica}
                    >
                      C/C
                    </ButtonItem>
                  </Tooltip>,
                  <Tooltip title={puedeOrdenCompra ? "Agregar factura a orden de compra con este xml" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      onClick={() => puedeOrdenCompra && this.abrirModalOrdenDeCompra(value._id)}
                      cafe
                      size='small'
                      disabled={!puedeOrdenCompra}
                    >
                      O.C.
                    </ButtonItem>
                  </Tooltip>
                );
              }

              // Botón de traspaso entre cuentas con divisas (tipo I)
              // const puedeTruspaso = value.contabilizada === 1 && value.tipoDeComprobante === 'I' && value.estado === 1 && value.estadoCancelacion !== 1;
              // if (puedeTruspaso) {
              //   buttons.push(
              //     <Tooltip title="Registrar como traspaso entre cuentas con divisas" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              //       <ButtonItem
              //         onClick={() => this.traspasoConDivisas(value._id)}
              //         size='small'
              //         style={{ backgroundColor: '#722ed1', borderColor: '#722ed1', color: 'white' }}
              //       >
              //         TRAS.
              //       </ButtonItem>
              //     </Tooltip>
              //   );
              // }

              // Botón de relacionar pago (tipo P)
              const puedeRelacionar = value.contabilizada === 1 && value.tipoDeComprobante === 'P' && value.estado === 1 && value.estadoCancelacion !== 1;
              if (puedeRelacionar) {
                buttons.push(
                  <Tooltip title={puedeRelacionar ? "Relacionar a un pago existente" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      onClick={() => puedeRelacionar && this.abrirRelacionarPago(value._id)}
                      blanco
                      size='small'
                      icon={<IconLink />}
                      disabled={!puedeRelacionar}
                    >
                    </ButtonItem>
                  </Tooltip>
                );
              }

              // Botones de vista previa y descargas
              const puedeVistaPrevia = value.tipoDeComprobante === 'P' || value.tipoDeComprobante === 'I' || value.tipoDeComprobante === 'E';
              const puedeDescargarPdf = value.tipoDeComprobante === 'P' || value.tipoDeComprobante === 'I' || value.tipoDeComprobante === 'E';
              const puedeDescargarXml = value.tipoDeComprobante === 'P' || value.tipoDeComprobante === 'I' || value.tipoDeComprobante === 'E';

              buttons.push(
                <Tooltip title={puedeVistaPrevia ? "Vista Previa" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    key={`vista-${index}`}
                    type="default"
                    size="small"
                    azul
                    icon={<EyeOutlined />}
                    onClick={() => puedeVistaPrevia && this.abrirVistaPrevia(value._id)}
                    disabled={!puedeVistaPrevia}
                  />
                </Tooltip>,
                <Tooltip title={puedeDescargarPdf ? "Descargar PDF" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    key={`pdf-${index}`}
                    type="default"
                    size="small"
                    blanco
                    icon={<FilePdfOutlined style={{ color: 'red' }} />}
                    onClick={() => puedeDescargarPdf && this.descargarPdf(value._id)}
                    disabled={!puedeDescargarPdf}
                  />
                </Tooltip>,
                <Tooltip title={puedeDescargarXml ? "Descargar XML" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    key={`xml-${index}`}
                    type="default"
                    size="small"
                    olivo
                    icon={<FileExcelOutlined />}
                    onClick={() => puedeDescargarXml && this.descargarXml(value._id)}
                    disabled={!puedeDescargarXml}
                  />
                </Tooltip>
              );

              // Botón ocultar/mostrar
              const poderOcultar = !value.oculto;
              if (poderOcultar) {
                buttons.push(
                  <Tooltip key="ocultar" title={"Ocultar"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      morado
                      size='small'
                      icon={<EyeInvisibleOutlined />}
                      onClick={() => this.ocultarXml(value._id)}
                    />
                  </Tooltip>
                );
              } else {
                buttons.push(
                  <Tooltip key="desocultar" title={"Mostrar"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      morado
                      size='small'
                      icon={<EyeOutlined />}
                      onClick={() => this.desocultarXml(value._id)}
                    />
                  </Tooltip>
                );
              }

              return (
                <div className="acciones-container">
                  {buttons}
                </div>
              );
            },
          },
        ];
    /*const datosFiltrados = this.state.todasArchivosXml.filter(item => {
      if (this.state.filtroTipo && item.tipoDeComprobante !== this.state.filtroTipo) return false;
      return true;
    });*/
    return (
      <>
        <PageHeader
          title={(
            <span>
              Archivos Xml
              &nbsp;
              <CloudServerOutlined />
            </span>
          )}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-end' }}>
              <Space>
                {window.innerWidth > 1000 &&
                  <SegmentedItem
                    options={[{ label: 'No Contabilizado', value: 1 }, { label: 'Contabilizado', value: 2 }, { label: 'Todas', value: 3 }, { label: 'Pendientes', value: 4 }, { label: 'Canceladas', value: 5 }, { label: 'Ocultos', value: 6 }]}
                   onChange={(value) => {
                      this.setState({ valor: value }, () => {
                        if (this.tableRef) {
                          this.tableRef.updateExternalFilters({
                            valor: value,
                            filtroTipo: this.state.filtroTipo,
                          });
                        }
                      });
                    }}
                    value={this.state.valor}
                  />}
              </Space>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Todas', value: '' }, { label: 'Ingreso', value: 'I' }, { label: 'Pago', value: 'P' }, { label: 'Egreso', value: 'E' }, { label: 'Nómina', value: 'N' }, { label: 'Traslado', value: 'T' }]}
                  value={this.state.filtroTipo}
                  //onChange={(value) => this.setState({ filtroTipo: value })}
                  onChange={(value) => {
                    this.setState({ filtroTipo: value }, () => {
                      if (this.tableRef) {
                        this.tableRef.updateExternalFilters({
                          valor: this.state.valor,
                          filtroTipo: value,
                        });
                      }
                    });
                  }}
                />}
                {this.state.todasUsosDeCFDI.length > 0 &&
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: 260 }}
                    placeholder="Filtrar por Uso de CFDI"
                    value={this.state.filtroUsoCfdi}
                    onChange={(valores) => this.onChangeFiltroUsoCfdi(valores)}
                  >
                    {this.state.todasUsosDeCFDI.map((u) => (
                      <Option value={u.c_UsoCFDI} key={u.c_UsoCFDI}>{this.textoUsoCfdi(u.c_UsoCFDI)}</Option>
                    ))}
                  </Select>}
                <ButtonItem
                  blanco
                  disabled={this.state.activasManual >= 3 || this.state.loading}
                  className="botonAgregar"
                  onClick={() => this.setState({ modalSolicitud: true, fechasSolicitud: [moment(), moment()] })}
                >
                  Actualizar
                </ButtonItem>
            </div>
          }
        />
        {this.state.selectedRowKeys.length > 0 && (
          <div style={{ backgroundColor: 'white', padding: '8px 16px', marginBottom: 10, border: '1px solid rgb(235, 237, 240)', display: 'flex', gap: 8, alignItems: 'center' }}>
            <span style={{ fontWeight: 500 }}>{this.state.selectedRowKeys.length} seleccionados</span>
            <ButtonItem size="small" morado icon={<EyeInvisibleOutlined />} onClick={() => this.ocultarMasivo(this.state.selectedRowKeys)}>
              Ocultar
            </ButtonItem>
            <ButtonItem size="small" morado icon={<EyeOutlined />} onClick={() => this.desocultarMasivo(this.state.selectedRowKeys)}>
              Mostrar
            </ButtonItem>
            <Tooltip
              title={this.state.selectedRowKeys.length > TOPE_VERIFICACION_XML_MASIVA
                ? `Puedes verificar hasta ${TOPE_VERIFICACION_XML_MASIVA} XML a la vez`
                : "Verificar en el SAT el estatus de los XML seleccionados"}
            >
              <span>
                <ButtonItem
                  size="small"
                  blanco
                  icon={<SearchOutlined style={{ color: '#00b5e2' }} />}
                  loading={this.state.iniciandoVerificacionMasiva}
                  disabled={this.state.procesandoVerificacion || this.state.selectedRowKeys.length > TOPE_VERIFICACION_XML_MASIVA}
                  onClick={() => this.verificarEstatusSeleccionados(this.state.selectedRowKeys)}
                >
                  Verificar estatus
                </ButtonItem>
              </span>
            </Tooltip>
            <ButtonItem size="small" blanco onClick={() => this.setState({ selectedRowKeys: [] })}>
              Cancelar
            </ButtonItem>
          </div>
        )}
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          totalRecords={this.state.totalRecords}
          onFetchData={this.consultarArchivosXml.bind(this)}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasArchivosXml}
          columns={columns}
          anadirValorFiltro={this.state.valor}
          valorDefault={1}
          setValor={(valor) => this.setState({ valor })}
          rowSelection={{
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (selectedRowKeys) => this.setState({ selectedRowKeys }),
          }}
          expandable={{
            rowExpandable: (record) => record.tipoDeComprobante === "I" || record.tipoDeComprobante === "E",
            expandedRowRender: (record) => (
              <ConceptosXmlPorXmlId
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                xmlId={record._id}
                todasProveedores={this.state.todasProveedores}
                todasTiposDeProveedor={this.state.todasTiposDeProveedor}
                todasMonedas={this.state.todasMonedas}
                onProveedorAlta={this.onProveedorAlta.bind(this)}
              />
            ),
          }}
        />
        <ModalItem
          title="Solicitar XML al SAT"
          visible={this.state.modalSolicitud}
          width={window.innerWidth > 1000 ? 480 : "95%"}
          footer
          okText="Solicitar"
          confirmLoading={this.state.loading}
          onOk={() => this.crearSolicitudDia()}
          onCancel={() => this.setState({ modalSolicitud: false })}
          destroyOnClose
          paddingTop
        >
          <p style={{ marginBottom: 8 }}>Rango de fechas de los CFDI a descargar:</p>
          <RangePickerItem
            style={{ width: "100%", marginBottom: 12 }}
            value={this.state.fechasSolicitud}
            onChange={(fechas) => this.setState({ fechasSolicitud: fechas })}
            allowClear={false}
            disabledDate={(fecha) => fecha && fecha.isAfter(moment().endOf('day'))}
          />
          <p style={{ marginBottom: 4 }}>
            Solo puedes realizar <strong>3 solicitudes</strong> por día.
          </p>
          <p style={{ marginBottom: 4 }}>
            En este momento llevas <strong>{this.state.activasManual || 0}</strong> de 3.
          </p>
          <p style={{ marginBottom: 0, color: "#888" }}>
            <em>
              * Si el rango termina hoy, se descarga hasta la hora actual. La primera solicitud suele ser la más rápida; las posteriores pueden tardar más.
            </em>
          </p>
        </ModalItem>
        <VistaPrevia
          visible={this.state.modalVistaPrevia}
          id={this.state.modalVistaPreviaId}
          cerrarVistaPrevia={this.cerrarVistaPrevia.bind(this)}
          todasProveedores={this.state.todasProveedores}
          todasTiposDeProveedor={this.state.todasTiposDeProveedor}
          todasMonedas={this.state.todasMonedas}
          onProveedorAlta={this.onProveedorAlta.bind(this)}
        />
        <RelacionarPago
          visible={this.state.modalRelacionarPago}
          id={this.state.modalRelacionarPagoId}
          cerrarRelacionarPago={this.cerrarRelacionarPago.bind(this)}
        />
        <AgregarAOrdenDeCompra
          visible={this.state.modalOrdenDeCompra}
          id={this.state.modalOrdenDeCompraId}
          history={this.props.history}
          cerrarModalOrdenDeCompra={this.cerrarModalOrdenDeCompra.bind(this)}
        />
        <ModalProgreso
          visible={this.state.procesandoVerificacion}
          titulo="Verificando en el SAT"
          descripcion="No cierres esta ventana: el proceso sigue en el servidor, pero perderías el avance en pantalla. Los XML se consultan de a pocos y con pausas para no saturar el servicio del SAT, así que tarda."
          procesados={this.state.progresoVerificacion.procesados}
          total={this.state.progresoVerificacion.total}
          unidad="XML"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ArchivosXml);
